import { Injectable } from '@angular/core';
import { Observable, forkJoin } from 'rxjs';
import { map, take, mergeMap } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Store } from '@ngrx/store';
import { IAppState } from 'src/app/store/state/app.state';
// import { GlobalEntitiesService } from './global-entities.service';
// import { SearchResult, SearchResultItem, SearchStatus } from '../../models/search.model';
import { environment } from 'src/environments/environment';
import { GlobalSearchEntitiesService } from './global-search-entities.service';
import { searchedClients, SearchResult, SearchResultItem, SearchStatus } from './search.model';
import { EntityType } from './entity-type.enum';
// import { searchedClients } from '../../models/search.model';
// import { EntityType } from '../../models/entity-type.enum';


@Injectable({
    providedIn: 'root'
})
export class  GlobalSearchService extends GlobalSearchEntitiesService {
    constructor(private http: HttpClient, store: Store<IAppState>) {
        super(store)
    }
    fetchGlobalSearch(prefix: string): Observable<SearchResult> {
        /**
         * Convert structure like this:
         * {
        "result": [
            {
                "name": "Lyoli",
                "id": 1,
                "type": "Venue",
                "child": {
                    "name": "Netop",
                    "id": 1,
                    "type": "Organization",
                    "child": {
                        "name": "DeLab,ENLabs,haha,Cisco Live US 2019,DevNet Sandbox,Forest City - Other",
                        "id": 2,
                        "type": "Tenant",
                        "child": null
                    }
                }
            }
        ],
        "num_of_results": 2
        }
        into SearchResult object
         */
        return this.orgId$.pipe(
            take(1),
            mergeMap((orgId) => {
                const globalSearch = this.http.get(`${environment.searchUrl}?prefix=${prefix}`);
                const clientSearch = this.http.get<searchedClients>(`organizations/${orgId}/search-clients?search=${prefix}`);
                return forkJoin([globalSearch, clientSearch])
            }),
            map(([searchResult, clientResult]) => {
                console.log("Search result: ", searchResult, "Client Search Result: ", clientResult.second);
                let result: SearchResult = new SearchResult();
                result.numOfResults = searchResult["num_of_results"];
                // build the reults structure
                let foundResults: SearchResultItem[] = [];

                this.prepareEntitiesResults(result, foundResults, searchResult);
                this.prepareClientsResults(result, foundResults, clientResult);
                result.foundEntityItems = foundResults
                console.log("result %o", result)
                return result
            })
        )
    }
    private prepareEntitiesResults(result: SearchResult, foundResults: SearchResultItem[], searchResult: Object) {
        for (let i = 0; i < searchResult["num_of_results"]; i++) {
            let resultItem = new SearchResultItem()
            // destructure the search result from the server to get the entity data
            let { name, id, type, child } = searchResult["result"][i];
            resultItem.entity = { name, id, type };
            resultItem.childEntity = null;
            foundResults.push(resultItem)
            // go over the results and get the hierarchy tree
            while (child) {
                let { name, id, type, child: grandChild } = child;
                let childResultItem = new SearchResultItem()
                childResultItem.entity = { name, id, type }
                childResultItem.childEntity = null
                resultItem.childEntity = childResultItem
                child = grandChild;
            }
        }
    }

    private prepareClientsResults(result: SearchResult, foundResults: SearchResultItem[], clientResult: searchedClients) {
        if (clientResult.first == SearchStatus.OK) {
            for (let i = 0; i < clientResult.second.length; i++) {
                if (clientResult.second[i].venue) {
                    result.numOfResults++;
                    let resultItem = new SearchResultItem();
                    resultItem.entity = {
                        id: +clientResult.second[i].venue.id,
                        name: clientResult.second[i].venue.name + " - " + clientResult.second[i].description,
                        type: EntityType.CLIENT
                    }
                    foundResults.push(resultItem);
                }
            }
        }
        else {
            result.numOfResults++;
            let resultItem = new SearchResultItem();
            resultItem.entity = {
                id: 1,
                name: SearchStatus.getFormattedSearchStatus(clientResult.first),
                type: EntityType.CLIENT
            }
            foundResults.push(resultItem);
        }
    }
}
